<template>
  <div class="table-responsive">
    <h6 class="booking-details-title"><translate>Flight:</translate> {{ item.label }}</h6>
    <table class="table table-sm text-center">
      <thead class="t-head thead-light text-center">
        <tr>
          <td v-translate>Flight</td>
          <td v-translate>Flight no.</td>
          <td v-translate>Date</td>
          <td v-translate>Depart</td>
          <td v-translate>Hour</td>
          <td v-translate>Arrival</td>
          <td v-translate>Hour</td>
        </tr>
      </thead>
      <tbody>
        <template v-for="(j, jIndex) in item.flight_info.journeys">
          <template v-for="(leg, legIndex) in j">
            <tr :key="'j' + jIndex + 'leg' + legIndex">
              <td>{{ jIndex ? $gettext('Departure') : $gettext('Return') }}</td>
              <td>{{ leg.airline }} {{ leg.flight }}</td>
              <td>{{ leg.date }}</td>
              <td>{{ leg.from_name }}</td>
              <td>{{ leg.depTime }}</td>
              <td>{{ leg.to_name }}</td>
              <td>{{ leg.arrTime }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'FlightItemInfo',
  props: ['item']
}
</script>
